import QRCode from 'qrcode';
import { useMemo } from 'react';

/**
 * A QR code drawn as SVG from the code's module matrix: no canvas, no innerHTML, and it
 * never leaves the page (the secret it carries is shown only during setup).
 */
export function Qr({ text, size = 196, label }: { text: string; size?: number; label: string }) {
  const { n, path } = useMemo(() => {
    const qr = QRCode.create(text, { errorCorrectionLevel: 'M' });
    const n = qr.modules.size;
    let path = '';
    for (let y = 0; y < n; y++) {
      for (let x = 0; x < n; x++) if (qr.modules.data[y * n + x]) path += `M${x + 4} ${y + 4}h1v1h-1z`;
    }
    return { n, path };
  }, [text]);
  return (
    <svg
      viewBox={`0 0 ${n + 8} ${n + 8}`}
      width={size}
      height={size}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect width={n + 8} height={n + 8} fill="#ffffff" />
      <path d={path} fill="#0f2a31" />
    </svg>
  );
}
